module.exports = __webpack_public_path__ + "static/img/09.0d5c97a5.jpg";